import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useApiClient } from "../api";
import { useAuthenticationStore } from "../stores/auth";

export const SingleSubjectSelectorDialog = ({ open, setOpen, user }) => {
  const [subject, setSubject] = useState("");
  const { updateUserInfo } = useAuthenticationStore();
  const [subjects, setSubjects] = useState([]);
  const ApiClient = useApiClient();

  const handleClose = () => {
    setSubject("");
    setOpen(false);
  };

  const handleSetTeacherSubject = async () => {
    try {
      const result = await ApiClient.users.updateTeacherInfo({
        school: user.info.teacher.school.id,
        subject: subject.id,
      });
      if (result.success) {
        const userData = await ApiClient.users.me();
        updateUserInfo(userData);
        handleClose();
      }
    } catch (error) {
      console.error("Failed to fetch registration data or terms:", error);
      setSubjects([]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Run both API calls in parallel
        const response = await ApiClient.core.getAllActiveSubjects();
        if (response) {
          setSubjects(response.allActiveSubjects);
        }
      } catch (error) {
        console.error("Failed to fetch registration data or terms:", error);
        setSubjects([]);
      }
    };
    fetchData();
  }, []);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Select Subject</DialogTitle>
      <DialogContent>
        <Typography variant={"subtitle1"}>Welcome to Fruitify!</Typography>
        <Typography variant={"body1"}>
          Choose your subject and then get started
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            gap: 10,
            mt: 2,
          }}
        >
          <Autocomplete
            sx={{ flexGrow: 1 }}
            options={subjects}
            getOptionLabel={(option) => option.name}
            value={subject || null} // single selection
            onChange={(_, newValue) => setSubject(newValue)}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField {...params} label="Subjects" variant="outlined" />
            )}
            disableClearable={false} // optional: allow clearing selection
            freeSolo={false} // prevents entering arbitrary text
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button
            onClick={handleSetTeacherSubject}
            variant="contained"
            disabled={!subject}
          >
            Select
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
